import { appendReduxPart } from "infrastructure/store";

import TranslationsHistoryFilter from "../translations-history/components/TranslationsHistoryFilter";

import { translationHistorySaga } from "./TranslationHistory.saga";
import { translationHistory } from "./TranslationHistory.slice";
import TranslationsHistory from "./TranslationsHistory";

export * from "./TranslationHistory.actions";
export * from "./TranslationHistory.state";
export * from "./TranslationHistory.slice";
export { TranslationsHistory, TranslationsHistoryFilter };
export * from "./components";

appendReduxPart(
  {
    reducerName: translationHistory.name,
    reducer: translationHistory.reducer
  },
  translationHistorySaga()
);
